export default "__VITE_ASSET__DmYwgPnU__"